<template>
  <Toast
    position="bottom-left"
    :pt="{
      root: 'max-sm:!w-[calc(100vw-theme(spacing.8))] max-sm:!bottom-18 !bottom-0 !left-4'
    }"
  />
</template>